var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Landing',{attrs:{"qaActions":_vm.qaActions},on:{"addDocument":function($event){return _vm.$emit('addDocument')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }